export const levels = (level: number) => {
  switch (level) {
    case 1:
      return '一阶';
    case 2:
      return '二阶';
    case 3:
      return '三阶';
    case 4:
      return '四阶';
  }
};
